/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Services_DescriptionInputs */

const en_meta_services_description = /** @type {(inputs: Meta_Services_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom AI agents, agent teams, research agents, lead generation systems, RAG knowledge bases, n8n workflow automation and complete AI systems, built in Latvia.`)
};

const lv_meta_services_description = /** @type {(inputs: Meta_Services_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI aģenti, aģentu komandas, izpētes aģenti, klientu piesaistes sistēmas, RAG zināšanu bāzes, n8n automatizācija un pilnas AI sistēmas, izstrādātas Latvijā.`)
};

/**
* | output |
* | --- |
* | "Custom AI agents, agent teams, research agents, lead generation systems, RAG knowledge bases, n8n workflow automation and complete AI systems, built in Latvia." |
*
* @param {Meta_Services_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_services_description = /** @type {((inputs?: Meta_Services_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Services_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_services_description(inputs)
	return en_meta_services_description(inputs)
});